/**
 * formatData — the export format registry (task 35.01 §7).
 *
 * Read by both sides: the server picks the writer, the client renders the format
 * list in the export dialog from this map rather than a hardcoded array. Adding a
 * format means adding an entry here and a writer module beside it.
 *
 * `values` is the default for that format, overridable per request:
 *   display  localized dates and numbers — a human opens this in a spreadsheet
 *   raw      ISO 8601, numbers as numbers — a machine reads it, and it is the
 *            only mode that could round-trip back in through an importer
 *
 * `importable` says a reader exists for the format as well as a writer, so the
 * import dialog can build its file filter from this map instead of hardcoding
 * one. A format may be write-only — a rendered report has no way back in.
 */
export const formatData = {
    csv: {
        label: 'export.format.csv',
        extension: 'csv',
        mime: 'text/csv; charset=utf-8',
        values: 'display',
        importable: true,
        maxRows: 10000,
        // No delimiter here: it follows the requester's locale (runExport).
        options: { bom: true }
    },
    xlsx: {
        label: 'export.format.xlsx',
        extension: 'xlsx',
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        // Raw on purpose: the sheet stores types and holds presentation in the
        // cell format, so localizing first would throw that away and leave text
        // that merely looks like numbers.
        values: 'raw',
        importable: true,
        maxRows: 10000,
        options: {}
    },
    json: {
        label: 'export.format.json',
        extension: 'json',
        mime: 'application/json; charset=utf-8',
        values: 'raw',
        importable: true,
        maxRows: 10000,
        options: { indent: 2 }
    }
}

export default formatData
